module.exports = __webpack_public_path__ + "static/media/info-circle.828894a7.svg";